module.exports = __webpack_public_path__ + "img/account-statement.c6e438dc.svg";